module.exports = __webpack_public_path__ + "img/ET.2651c5e3.svg";